import * as React from 'react';
import * as I18n from 'i18n-js';
import { get } from 'lodash';
import { I18N } from '../components/translate';
import {
  core_apimessages_ShippingPrice,
  Listing,
  core_apimessages_ShippingMethod,
  Shop,
} from '../rql';
import { SHOP_PATH } from '../url_helpers';

function hasExpeditedShipping(listing?: Listing): boolean {
  const shippingPrices = get(listing, 'shipping.shippingPrices') || [];

  const expeditedShipping = shippingPrices.filter((price: core_apimessages_ShippingPrice) =>
    price.shippingMethod === core_apimessages_ShippingMethod.EXPEDITED_SHIPPING,
  );

  return expeditedShipping.length > 0;
}

export function CombinedSaleAndShippingNotice(props: { listing?: Listing }) {
  if (!hasExpeditedShipping(props.listing) && !get(props.listing, 'sale.id')) {
    return null;
  }

  if (!hasExpeditedShipping(props.listing) && get(props.listing, 'sale.id')) {
    return (
      <p className="offers-form__notice offers-form__notice--sale">
        {I18n.t('commons.offers.saleNotice')}
      </p>
    );
  }

  if (hasExpeditedShipping(props.listing) && !get(props.listing, 'sale.id')) {
    return (
      <p className="offers-form__notice offers-form__notice--shipping">
        {I18n.t('commons.offers.freeTwoDayShippingNotice')}
      </p>
    );
  }

  return (
    <p className="offers-form__notice offers-form__notice--sale">
      {I18n.t('commons.offers.combinedSaleShippingNotice')}
    </p>
  );
}

export function TimelineNotice(props: { shop?: Shop }) {
  const shopName = get(props, 'shop.name');

  if (!shopName) {
    return null;
  }

  return (
    <p className="offers-form__notice offers-form__notice--time">
      {I18n.t('commons.offers.timeline', { shopName })}
    </p>
  );
}

export function SalesTaxNotice(props: { shop?: Shop }) {
  const slug = get(props, 'shop.slug');

  return (
    <p className="offers-form__notice offers-form__notice--tax">
      <I18N
        html
        text="commons.offers.salesTaxMayBeApplied"
        args={{
          linkOpen: `<a href="${SHOP_PATH.expand({ slug })}/about" target="_blank">`,
          linkClose: '</a>',
        }}
      />
    </p>
  );
}
